export function SupportLink() {
    return <a href="mailto:support@nordoon.ai" className="text-space_blue-500 cursor-pointer hover:underline">support</a>;
}